import './cafemosaic/style';
import FormStructure from './cafemosaic/form_structure';

export default FormStructure;